export enum SchemaId {
    meetingsSchedule = "MeetingsSchedule"
}